export default __webpack_public_path__ + "assets/images/22bec5f6ef6ee81716610dba13c12450.svg";